import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Audiences from "@/components/Audiences";
import AboutSummary from "@/components/AboutSummary";
import MethodsPreview from "@/components/MethodsPreview";
import TherapyPreview from "@/components/TherapyPreview";
import ProgramsPreview from "@/components/ProgramsPreview";
import BookingPreview from "@/components/BookingPreview";
import AnalysisPreview from "@/components/AnalysisPreview";
import Testimonials from "@/components/Testimonials";
import BlogPreview from "@/components/BlogPreview";
import Shop from "@/components/Shop";
import Footer from "@/components/Footer";
import { useLanguage } from "@/i18n/LanguageContext";

const Home = () => {
    const location = useLocation();
    const { t } = useLanguage();

    useEffect(() => {
        const seo = t.page_meta?.seo?.home;
        if (seo) {
            document.title = seo.title;
            const meta = document.querySelector('meta[name="description"]');
            if (meta) meta.setAttribute("content", seo.description);
        }
    }, [t]);

    useEffect(() => {
        const els = document.querySelectorAll(".reveal");
        const obs = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("is-visible");
                        obs.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.12 },
        );
        els.forEach((el) => obs.observe(el));
        return () => obs.disconnect();
    }, []);

    // Smooth scroll to hash anchor when arriving from another route (e.g. /#audiences)
    useEffect(() => {
        if (location.hash) {
            const id = location.hash.replace("#", "");
            const el = document.getElementById(id);
            if (el) {
                setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 80);
            }
        }
    }, [location]);

    return (
        <div data-testid="home-page">
            <Header />
            <main>
                <Hero />
                <Audiences />
                <AboutSummary />
                <MethodsPreview />
                <TherapyPreview />
                <ProgramsPreview />
                <BookingPreview />
                <AnalysisPreview />
                <Testimonials />
                <BlogPreview />
                <Shop />
            </main>
            <Footer />
        </div>
    );
};

export default Home;
